/**
 * Public API for Marketplace
 * This is the public API for the Marketplace service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetOfferPaymentMethods403Response { 
    error_key?: GetOfferPaymentMethods403Response.ErrorKeyEnum;
}
export namespace GetOfferPaymentMethods403Response {
    export type ErrorKeyEnum = 'promocode.prohibited';
    export const ErrorKeyEnum = {
        PromocodeProhibited: 'promocode.prohibited' as ErrorKeyEnum
    };
}


